import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RptloanpopupComponent } from "../../../shared/popup/rptloanpopup/rptloanpopup.component";
import { CommonmastersService } from "../../../../commonmasters/commonmasters.service";
import { Employee } from "../../../../login/shared/employee";
import { formatDate } from "@angular/common";
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-financialyearpopup',
  templateUrl: './financialyearpopup.component.html',
  styleUrls: ['./financialyearpopup.component.css']
})
export class FinancialyearpopupComponent implements OnInit {

  BranchList: any[] = [];
  FinancialYearList: any[] = [];
  selectedEmployee: Employee;

  constructor(public dialogRef: MatDialogRef<RptloanpopupComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonmastersService: CommonmastersService) { }

  ngOnInit() {
    this.GetFinancialYear();
    this.GetBranch();
    // this.data.BranchId = 0;
    // this.data.YearId = 0;
  }

  ChangeBranch(): void {

    let BranchName = this.BranchList.filter(item => item.Id == this.data.BranchId)[0].Name;
    let BranchId = this.data.BranchId;

    let localStorageJsonData = JSON.parse(localStorage.getItem("EmployeeData"));
    localStorageJsonData.EmployeeBranchName = BranchName;
    localStorageJsonData.BranchId = BranchId;

    localStorage.setItem("EmployeeData", JSON.stringify(localStorageJsonData));

    let YearName = this.FinancialYearList.filter(item => item.Id == this.data.YearId)[0].Name;
    localStorage.setItem("FinancialYear", YearName);         // Financial Year

    let FromDate = this.FinancialYearList.filter(item => item.Id == this.data.YearId)[0].Name;
    localStorage.setItem("FromDate", FromDate);
    let ToDate = this.FinancialYearList.filter(item => item.Id == this.data.YearId)[0].Name;
    localStorage.setItem("ToDate", ToDate);

    let Branch_year = BranchName + ',' + YearName;
    this.dialogRef.close(Branch_year);

    this.SelectBranchDate(BranchId); // to change the application date simultaneously
  }

  GetBranch() {
    this.commonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;
      this.data.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    })
  }

  GetFinancialYear() {
    this.commonmastersService.GetFinancialYearList().subscribe(data => {
      this.FinancialYearList = data;
      this.data.YearId = this.FinancialYearList[0].Id; // here we selecting the last element of the list
    })
  }

  SelectBranchDate(BranchId: any) {  // for change of application date

    if (BranchId != 0) {
      const format = 'MMM d, y';
      const locale = 'en-US';
      let RetApplicationDate = this.commonmastersService.GetApplicationDate(BranchId).toPromise()
        .then(data => {

          setTimeout(function() {
          if(data != null){
           
            const formattedDate = formatDate(data.ApplicationDate, format, locale);
            // localStorage.removeItem("ApplicationDate");
            // localStorage.setItem("ApplicationDate", formattedDate);

            var appObj = JSON.parse(localStorage.getItem("EmployeeData")); // to loantransaction
            appObj.ApplicationDate = formattedDate; 
            localStorage.setItem("EmployeeData", JSON.stringify(appObj));

            this.router.navigate(['./customerlist']);
          }
          else{
            const formattedDate = formatDate(new Date(), format, locale);
            // localStorage.removeItem("ApplicationDate");
            // localStorage.setItem("ApplicationDate", formattedDate);

            var appObj = JSON.parse(localStorage.getItem("EmployeeData")); // to loantransaction
            appObj.ApplicationDate = formattedDate; 
            localStorage.setItem("EmployeeData", JSON.stringify(appObj));

            this.router.navigate(['./customerlist']);
          }      
        //  return Promise.resolve(data); 
         }, 6000);               
        });
      }
  }
}
